import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Alert } from 'us-react-components/dist/Alert/Alert';
import { getAdminUrl } from 'us-react-components/dist/utils/string';
import { ParentService, UserService } from 'us-web-services';

import { Link, NavLink } from '..';
import { Button, ButtonSize, ButtonType, KinsideButton } from '../Button';
import { Storage } from '../../constants';
import { useDependencies } from '../../dependencies';
import GiveButton from './components/GiveButton';
import Notifications from './components/Notifications';
import Profile from './components/Profile';
import MainLinks from './components/MainLinks';
import Messages from './components/Messages';

const LOGO_URL = 'https://assets.urbansitter.com/static/img/logos/urbansitter_logo_color.svg';

type Props = {
  isDashboard: boolean;
}

export const MainHeader = ({ isDashboard }: Props): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useSharedTranslation(namespaces.family);
  const isParent = stores.user.user?.parent || false;
  const { hasKinsidePartnership } = stores.parent;

  const getName = (): string => `${stores.parent.parent?.firstName} ${stores.parent.parent?.lastName}`;

  const isMasquerading = (): boolean => localStorage.getItem(Storage.ORIGINAL_USER_ID) !== null;

  const unMasquerade = async (): Promise<void> => {
    const adminId = Number(localStorage.getItem(Storage.ORIGINAL_USER_ID));
    const adminUser = (await UserService.get(adminId)).data.data;
    const adminParent = (await ParentService.get(adminId)).data.data;

    localStorage.setItem(Storage.US_USER_OBJECT, JSON.stringify(adminUser));
    localStorage.setItem(Storage.US_PARENT_OBJECT, JSON.stringify(adminParent));
    localStorage.removeItem(Storage.FAMILY_REGISTRATION_STORE);
    localStorage.removeItem(Storage.ORIGINAL_USER_ID);
    localStorage.removeItem(Storage.US_SITTER_OBJECT);
    localStorage.removeItem(Storage.US_USER_TESTS_OBJECT);

    window.location.href = getAdminUrl();
  };

  return (
    <>
      <header className='py-3.5 shadow'>
        <div className='container flex lg:relative'>
          <nav className='shrink-0 mt-0 md:flex md:w-9/12'>
            <NavLink to={isParent ? '/family/dashboard' : '/caregiver/dashboard'} end>
              <img
                src={LOGO_URL}
                alt={t('components.header.logo.alt')}
                className='hidden lg:inline-block mr-4 w-auto'
                id='urbansitter-logo-desktop'
              />
              <img
                src={LOGO_URL}
                alt={t('components.header.logo.alt')}
                className='inline-block lg:hidden -ml-2 mt-2 flex w-8/12'
                id='urbansitter-logo-mobile'
              />
            </NavLink>
            <div className='md:flex hidden w-9/12 justify-center'><MainLinks /></div>
          </nav>
          <div className='flex flex-row justify-end text-right absolute right-1'>
            {hasKinsidePartnership && !isDashboard && <KinsideButton />}
            {isParent && !isDashboard && <GiveButton />}
            <Messages />
            <Notifications />
            <Profile />
          </div>
        </div>
      </header>
      {isMasquerading() && (
        <div className='w-full mx-auto mt-[1px]'>
          <Alert color='warning' isOpen={isMasquerading()}>
            Masquerading as <Link className='font-bold text-sapphire' to={`/parent/${stores.parent.parent?.id}`}>{getName()}</Link>
            <Button buttonSize={ButtonSize.small} buttonType={ButtonType.primary} className='ml-5 !py-1 !px-4' onClick={unMasquerade}>Switch back</Button>
          </Alert>
        </div>
      )}
    </>
  );
};
